import { ApiService } from './api.service'

const BaseUrl = '/au-pay'

export function auPayExchangePoint (params = {}) {
  return ApiService.post(`${BaseUrl}/exchange`, params).then(resp => resp.data)
}
